/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type ExternalAgentMessageRole =
  (typeof ExternalAgentMessageRole)[keyof typeof ExternalAgentMessageRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalAgentMessageRole = {
  user: 'user',
  assistant: 'assistant',
} as const;
